import {
  Link,
  type LinkProps
} from '@chakra-ui/react';

export type UiLinkProps = LinkProps;

export const UiLink = Link;
